import React, { Component } from "react";
import {
  Grid,
  Zoom,
  Divider,
  Button,
  IconButton,
  Card,
  Step,
} from "@material-ui/core";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import {
  Email,
  ExpandMore,
  Redo,
  Lens,
  MonetizationOn,
  LocationOn,
  DateRange,
  Clear,
  Done,
  Edit,
  Error,
  Search,
  Group,
} from "@material-ui/icons";
import { fonts, colors, metrics } from "../../styles";
import { connect } from "react-redux";
import { setUsers } from "../../actions/usersActions";
import View from "./View";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import ColorService from "../../tools/ColorsService";
import SendEmailAlert from "./SendEmailAlert";

import { constants } from "../../config";
import Modal from "./EditDetails";
import shuttle from "../../images/shutleDetails.svg";
import MissionService from "../../tools/MissionService";
import FlightStageService from "../../tools/FlightStageService";
import { CheckCircle } from "@material-ui/icons";
import { MissionStatusNotAuthorized, MISSION_STATUS } from "../../enums";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);
class Flights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // warning:colors.regular,
      step: 0,
      currentStage: {},
      dialogEmail: false,
      idEmail: "",
      // openCollapse: -1,
      shutle: {
        flight_stages: [],
      },
      steps: [],
      loading: false,
      loadingEdit: true,
      openModal: false,
      index: -1,
      btnEditHover: false,
      profileUser: JSON.parse(localStorage.getItem(constants.userKey)).user
        .profile,
    };
  }
  componentWillMount() {
    MissionService.getById(this.props.match.params.id).then((response) => {
      console.log("response willmount:", response.response);
      if (response.ok) {
        let shutle = response.response;
        this.setState({ shutle: shutle, loadingEdit: false });
      }
    });
  }

  handleRefresh = () => {
    this.setState({ loadingEdit: true });

    MissionService.getById(this.props.match.params.id).then((response) => {
      if (response.ok) {
        console.log("refresh:", response);
        let shutle = response.response;
        this.setState({ loadingEdit: false, shutle: shutle });
        this.forceUpdate();
      }
    });
  };

  handleAuthorizeStage = (
    stage,
    title = "Deseja realmente alterar essa etapa?"
  ) => {
    Swal.fire({
      title: "Deseja realmente alterar essa etapa?",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (result.value) {
        if (stage.status !== MISSION_STATUS.AUTORIZADO) {
          stage.status = MISSION_STATUS.AUTORIZADO;
        } else {
          stage.status = MISSION_STATUS.CONFIRMADO;
        }

        stage.authorized = true;
        this.setState({ loading: true });
        if (stage.passengers) {
          stage.passengers = stage.passengers.map((item) => item.id);
        }
        FlightStageService.update(stage.id, stage).then((result) => {
          this.setState({ loading: false });
          if (result.ok) {
            MySwal.fire({
              title: "<p>Status salvo com sucesso!</p>",
              type: "success",
            });
            this.handleRefresh();
          } else {
            MySwal.fire({
              title: "<p>Erro ao salvar Status!</p>",
              type: "error",
            });
          }
        });
      }
    });
  };

  openModal = () => {
    console.log(this.state);
    this.setState({ openModal: !this.state.openModal });
  };

  buttonEditHover = () => {
    // this.setState({ btnEditHover: !this.state.btnEditHover });
  };

  // openCollapse = async (index) => {
  //   let fast = this.state.openCollapse === -1;
  //   await this.setState({ openCollapse: -1 });
  //   if (!fast) {
  //     let time = setInterval(() => {
  //       this.setState({ openCollapse: index });
  //       clearInterval(time);
  //     }, 700);
  //   } else {
  //     this.setState({ openCollapse: index });
  //   }
  // };

  openAlert = (id) => {
    // this.setState({ dialogEmail: !this.state.dialogEmail, idEmail: id });
  };

  render() {
    var styleEditButton = {
      width: "20%",
      height: "100%",
      padding: 0,
      margin: 0,
      backgroundColor: "rgba(0,0,0,0.12)",
      float: "right",
      color: colors.regular,
    };

    if (this.state.btnEditHover) {
      styleEditButton.backgroundColor = "rgba(0,0,0,0.3) !important";
    } else {
      styleEditButton.backgroundColor = "rgba(0,0,0,0.12)";
    }

    return (
      <Zoom in={true}>
        <Grid container style={{ alignItems: "center" }}>
          <View
            status={this.state.shutle.status}
            shutle={this.state.shutle}
            loadingEdit={this.state.loadingEdit}
          />
          {this.state.profileUser !== "Passageiro" && (
            <Modal
              handleRefresh={this.handleRefresh}
              id={this.props.match.params.id}
              index={this.state.index}
              step={this.state.step}
              shutle={this.state.shutle}
              open={this.state.openModal}
              openModal={this.openModal}
              currentStage={this.state.currentStage}
            />
          )}
          <SendEmailAlert
            id={this.state.idEmail}
            missionId={this.state.shutle.id}
            sentEmail={this.state.sentEmail}
            loadingEmail={this.state.loadingEmail}
            close={this.openAlert}
            open={this.state.dialogEmail}
          />
          <Grid container justify={"center"} style={styles.iboxMain}>
            {this.state.loadingEdit ? (
              <CircularProgress size={60} />
            ) : (
              this.state.shutle.flight_stages.map((el, index) => {
                // if (this.state.openCollapse != index)
                return (
                  <Card
                    style={{
                      width: "100%",
                      marginBottom: 4,
                      padding: 16,
                      marginLeft: 10,
                      marginRight: 10,
                    }}
                    key={index}
                    onClick={() => {
                      this.setState({
                        index: index,
                        currentStage: el,
                        step: 0,
                      });
                      this.openModal();
                    }}
                  >
                    <Grid container>
                      <Grid
                        container
                        item
                        md={12}
                        style={{
                          fontFamily: "Roboto",
                          color: colors.regular,
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Grid item md={1}>
                          <h4 style={{ cursor: "pointer" }}>
                            Etapa {index + 1}
                          </h4>
                          <span
                            style={{
                              fontSize: 12,
                              padding: 6,
                              backgroundColor: ColorService.backgroundColor(
                                el.status
                              ),
                              borderRadius: 3,
                              color: ColorService.contrastColor(el.status),
                            }}
                          >
                            {el.status}
                          </span>
                        </Grid>
                        <Grid container item md={11}>
                          <Grid
                            container
                            item
                            md={5}
                            sm={4}
                            style={{
                              fontFamily: "Roboto",
                              justifyContent: "center",
                              color: colors.regular,
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            <Grid item md={12}>
                              <span style={{ fontSize: 13 }}>ORIGEM </span>
                              {el.from ? (
                                <h4 style={{ margin: 5 }}>{el.from}</h4>
                              ) : (
                                <h4 style={{ margin: 5 }}> </h4>
                              )}
                            </Grid>
                            <Grid container item md={12}>
                              <Grid item md={6} style={styles.item}>
                                {/* <CalendarToday font={13} /> */}
                                <span style={{ fontSize: 11 }}>DECOLAGEM</span>
                                {el.departure_date ? (
                                  <h5 style={{ margin: 5 }}>
                                    {moment(el.departure_date)
                                      .format("DD/MMM/YYYY")
                                      .toUpperCase()}
                                  </h5>
                                ) : (
                                  <h5 style={{ margin: 5 }}>{"--/--/--"}</h5>
                                )}
                              </Grid>
                              <Grid item md={6} style={styles.item}>
                                <span style={{ fontSize: 11 }}>HORA LOCAL</span>
                                <h5 style={{ margin: 5 }}>
                                  {el.local_time
                                    ? el.local_time.split(":")[0] +
                                      ":" +
                                      el.local_time.split(":")[1]
                                    : "-- : --"}
                                </h5>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            style={{
                              justifyItems: "center",
                              alignItems: "center",
                            }}
                            item
                            md={2}
                            sm={4}
                          >
                            <Grid item md={10}>
                              <img src={shuttle} />
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            md={4}
                            sm={4}
                            style={{
                              width: "inherit",
                              fontFamily: "Roboto",
                              justifyContent: "center",
                              color: colors.regular,
                              alignItems: "center",
                              textAlign: "center",
                              alignContent: "center",
                            }}
                          >
                            <Grid item md={12}>
                              <span style={{ fontSize: 13 }}>DESTINO</span>
                              {el.to ? (
                                <h4 style={{ margin: 5 }}>{el.to}</h4>
                              ) : (
                                <h4 style={{ margin: 5 }}></h4>
                              )}
                            </Grid>
                            <Grid container item md={12}>
                              <Grid item md={6} style={styles.item}>
                                {/* <CalendarToday font={13} /> */}
                                <span style={{ fontSize: 11 }}>CHEGADA</span>
                                {el.arrival_date ? (
                                  <h5 style={{ margin: 5 }}>
                                    {moment(el.arrival_date)
                                      .format("DD/MMM/YYYY")
                                      .toUpperCase()}
                                  </h5>
                                ) : (
                                  <h5 style={{ margin: 5 }}>{"--/--/--"}</h5>
                                )}
                              </Grid>
                              <Grid item md={6} style={styles.item}>
                                {/* <QueryBuilder font={13} /> */}
                                <span style={{ fontSize: 11 }}>HORA LOCAL</span>
                                {el && (
                                  <h5 style={{ margin: 5 }}>
                                    {el.arrival_time
                                      ? el.arrival_time.split(":")[0] +
                                        ":" +
                                        el.arrival_time.split(":")[1]
                                      : "-- : --"}
                                  </h5>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            md={1}
                            sm={1}
                            alignItems="center"
                            alignContent="center"
                            style={{ width: "inherit" }}
                          >
                            <Tooltip title="Total de passageiros">
                              <IconButton
                                color="inherit"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.setState({
                                    index: index,
                                    currentStage: el,
                                    step: 2,
                                  });
                                  this.openModal();
                                }}
                              >
                                <Group color="action" />
                                <span
                                  style={{
                                    color: "action",
                                    fontSize: 18,
                                    marginLeft: 4,
                                  }}
                                >
                                  {el.passengers.length}
                                </span>
                              </IconButton>
                            </Tooltip>
                            <IconButton color="inherit">
                              <Search></Search>
                            </IconButton>
                            {(MissionStatusNotAuthorized.includes(el.status) ||
                              el.status === MISSION_STATUS.AUTORIZADO) && (
                              <Tooltip
                                title={
                                  el.status === MISSION_STATUS.AUTORIZADO
                                    ? "AUTORIZAÇÃO 1"
                                    : "AUTORIZAÇÃO 2"
                                }
                              >
                                <IconButton
                                  color="inherit"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    const title =
                                      el.status === MISSION_STATUS.AUTORIZADO
                                        ? "Deseja realmente Confirmar essa etapa?"
                                        : "Deseja realmente Autorizar essa etapa?";
                                    this.handleAuthorizeStage(el, title);
                                  }}
                                >
                                  <CheckCircle />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                        <div style={{ marginTop: 20 }}>{el.observations}</div>
                      </Grid>
                    </Grid>
                  </Card>
                );
              })
            )}
          </Grid>
        </Grid>
      </Zoom>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users,
});

const mapDispatchToProps = {
  setUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(Flights);

const styles = {
  iboxMain: {
    paddingLeft: metrics.paddingPage + 30,
    paddingRight: metrics.paddingPage + 30,
    marginTop: -20,
    marginBottom: 20,
  },
  paper: {
    padding: metrics.paddingPage,
  },
  item: {
    alignItems: "center",
    fontFamily: "Roboto",
    textAlign: "center",
    width: "inherit",
    color: colors.regular,
  },
};



// WEBPACK FOOTER //
// ./src/routes/flight/index.js